import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChNotificationComponent } from './ch-notification.component';


export class ChNotificationModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [ChNotificationComponent],
  exports: [ChNotificationComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
